import { memo } from 'react';
import QueryString from 'qs';
import ApiaApi, { makeApiaUrl } from '../../../../../api/apiaApi/apiaApi';
import { TApiaFunction, TApiaLoad } from '../../../../../types';
import { arrayOrArray } from '../../../../../utils/util';
import { TResponsiveTableCellRenderer } from '../../../../common/generic/responsiveTable/types';
import actions from '../../../../../api/apiaApi/actions';
import makeAsyncRenderer from '../../../../common/generic/responsiveTable/renderers/makeAsyncRenderer';

const InnerRender: TResponsiveTableCellRenderer = makeAsyncRenderer(
  async (row) => {
    const id = row.id.slice(
      0,
      row.id.indexOf('$-$') > 0 ? row.id.indexOf('$-$') : row.id.length,
    );

    const result = await ApiaApi.post<
      TApiaLoad<
        TApiaFunction<{
          row: { cell: { label?: string; name: string; newLine?: boolean } };
        }>
      >
    >(
      makeApiaUrl({
        action: actions.common.lists.adtInfo,
        isAjax: true,
        preventAsXmlParameter: true,
      }),
      {
        postData: QueryString.stringify({
          id,
        }),
      },
    );

    if (result && result.data) {
      const resultCells = arrayOrArray(
        arrayOrArray(result.data.function.messages.row)[0].cell,
      );

      if (typeof resultCells !== 'string') {
        return resultCells;
      }
    }
    return [];
  },
);
const AsyncRenderer = memo(InnerRender);

export default AsyncRenderer;
